import React from 'react';
import CommonSidebar from "../Common/CommonSidebar";

//icons
import QueryStatsIcon from "@mui/icons-material/QueryStats";
import CalculateIcon from '@mui/icons-material/Calculate';
import AssessmentIcon from '@mui/icons-material/Assessment';
import ModelTrainingIcon from '@mui/icons-material/ModelTraining';
import DeveloperBoardIcon from '@mui/icons-material/DeveloperBoard';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import ListIcon from "@mui/icons-material/List";
import PeopleIcon from "@mui/icons-material/People";


class FinancialSidebar extends React.Component {
    render() {
        return(
            <CommonSidebar
                groups={
                    [
                        {
                            title: 'Управление',
                            items: [
                                {
                                    title: 'Банковские транзакции',
                                    link: '/financial/bank_transaction/',
                                    icon: AccountBalanceWalletIcon,
                                },
                                {
                                    title: 'Сотрудники',
                                    link: '/employee/',
                                    icon: PeopleIcon,
                                },
                                {
                                    title: 'Премии',
                                    link: '/financial/bonus/',
                                    icon: ListIcon,
                                },
                                {
                                    title: 'Расходы - единоразовые',
                                    link: '/financial/overhead_once/',
                                    icon: ListIcon,
                                },
                                {
                                    title: 'Расходы - периодические',
                                    link: '/financial/overhead_periodic/',
                                    icon: ListIcon,
                                },
                            ]
                        },
                        {
                            title: 'Анализ',
                            items: [
                                {
                                    title: 'Фин. отчет',
                                    link: '/financial/report/',
                                    icon: AssessmentIcon,
                                },
                                {
                                    title: 'Загрузка',
                                    link: '/financial/labor/',
                                    icon: DeveloperBoardIcon,
                                },
                                {
                                    title: 'Вычислитель',
                                    link: '/financial/calculator/',
                                    icon: CalculateIcon,
                                },
                                {
                                    title: 'Статистика сделок',
                                    link: '/financial/opportunity_financial_report/',
                                    icon: QueryStatsIcon,
                                },

                            ],
                        },
                        {
                        title: 'Моделирование',
                        items: [
                            {
                                title: 'Фин. модель',
                                link: '/financial/model/',
                                icon: ModelTrainingIcon,
                            },
                        ],
                    }
                    ]
                }
            />
        )
    }
}

export default FinancialSidebar;